import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-601a14e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-4" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "d-flex align-items-center button-wrapper cursor-pointer" }
const _hoisted_5 = { class: "col-form-label fw-bold mb-2 fs-9" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "bg-white-50 p-4 mb-5 rounded-4 align-items-center" }
const _hoisted_8 = { class: "row mx-4" }
const _hoisted_9 = { class: "row pb-4 d-flex align-items-center border-bottom" }
const _hoisted_10 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "search-container position-relative" }
const _hoisted_13 = ["placeholder", "maxlength"]
const _hoisted_14 = { class: "row mb-4 py-4 border-bottom" }
const _hoisted_15 = { class: "col-lg-2 fs-7" }
const _hoisted_16 = { class: "col-lg-10 d-lg-flex" }
const _hoisted_17 = ["for"]
const _hoisted_18 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_19 = { class: "row pb-4 mb-4 border-bottom" }
const _hoisted_20 = { class: "col-lg-2 fs-7" }
const _hoisted_21 = { class: "col-lg-10" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = { class: "row pb-4 mb-4 d-flex align-items-center border-bottom" }
const _hoisted_26 = { class: "col-lg-2 col-form-label fs-7" }
const _hoisted_27 = { class: "col-lg-6" }
const _hoisted_28 = { value: "" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "fw-bold mb-4 col-lg-12" }
const _hoisted_31 = { class: "dashboard px-3 py-4 rounded mb-4" }
const _hoisted_32 = { class: "tab-header-custom d-flex justify-content-center align-items-center m-0 mb-4 mb-lg-5 p-0" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "has-message position-absolute"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))
const _hoisted_36 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_37 = {
  class: "bg-white rounded-4 shadow p-4 mb-5",
  id: "data-table"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { omit } from 'lodash'

import Button from '@/components/button/index.vue'
import TableUsers from './table-users/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Loading from '@/components/loading/index.vue'
import InfoFilter from '@/views/community-admin/user-management/alumni-user/info-filter/index.vue'
import FlagFilter from '@/views/community-admin/user-management/alumni-user/flag-filter/index.vue'
import ActionFilter from '@/views/community-admin/user-management/alumni-user/action-filter/index.vue'

import { MAX_LENGTH_USER_NAME_SEARCH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_STORE, CONVERSATIONS_STORE, GROUPS_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const route = useRoute()

const showAdvanceSearch = ref(true)
const listGroups = computed(() => store.getters[GROUPS_STORE.GETTERS.ALL_GROUPS])
const dataSearch = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DATA_SEARCH_ALUMNUS])
const loading = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_COMMUNITY_ALUMNUS]?.loading)

const formData = ref({
  keyword: '',
  status: 'examinated',
  direct: false,
  group_id: '',
  detail_search: {
    community_info: {
      birthday: {
        start: '',
        end: '',
      },
      email: '',
      institution: '',
      job_type_parent_id: '',
      job_type_child_id: '',
      enrollment_start_period: '',
      portfolio_personal_activities: {
        title: '',
        content: '',
      },
      portfolio_work_histories: {
        position: '',
        department_name: '',
        content: '',
        portfolio_work_history_corporation_name: '',
        job_type_parent_id: '',
        job_type_child_id: '',
        start_period: '',
        end_period: '',
      },
      management_no: [],
      address: '',
      additional_information_1: '',
      additional_information_2: '',
      additional_information_3: '',
      additional_information_4: '',
      additional_information_5: '',
      corporation_organization_name: '',
      corporation_department_name: '',
      corporation_start_period: '',
      corporation_end_period: '',
    },
    management_flag: {
      flag_id: [],
      condition: '', //and || 'or'
      condition_not: false,
    },
    actions: {
      start_period: '',
      end_period: '',
      action_search_detail: [
        {
          action_search: '',
          action_count: {
            from: '',
            to: '',
          },
        },
      ],
    },
  },
})

const dataTable = ref({
  keyword: '',
  status: 'examinated',
  direct: false,
  group_id: '',
})

const tabs = [
  {
    title: translate('OE10infoSearch'),
    alias: 'info',
  },
  {
    title: translate('OE10flagSearch'),
    alias: 'flag',
  },
  {
    title: translate('OE10actionSearch'),
    alias: 'action',
  },
]

const tabNow = ref('info')
const tabInfo = ref(true)
const tabFlag = ref(false)
const tabAction = ref(false)
const changeTab = (alias: string): void => {
  tabNow.value = alias
  if (alias === 'info') {
    tabInfo.value = true
    tabFlag.value = false
    tabAction.value = false
  } else if (alias === 'flag') {
    tabInfo.value = false
    tabFlag.value = true
    tabAction.value = false
  } else {
    tabInfo.value = false
    tabFlag.value = false
    tabAction.value = true
  }
}
const isFilter = ref<boolean>(false)

const onSubmit = async (): Promise<void> => {
  try {
    dataTable.value = { ...formData.value }
    let paramSearch = {
      formData: formData.value,
      tabNow: tabNow.value,
    }
    await store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DATA_SEARCH_ALUMNUS, paramSearch)

    // 2022/11/09 TienNV Fix bug select all data  UAT#4500: OE10(Ph2-R20221111)
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_ALL_DATA, {
      id: route.params?.id,
      data: {
        ...dataTable.value,
        group_id: route.query?.group_id ?? dataTable.value?.group_id,
      },
      typeData: 'alumni',
    })

    await getCommunityAlumnus({
      data: { keyword: formData.value.keyword, direct: formData.value.direct, status: formData.value.status, detail_search: formData.value.detail_search },
      params: {
        group_id: formData.value.group_id,
        ...omit(router.currentRoute.value.query, 'group_id'),
        page: 1,
        page_of_number: router.currentRoute.value.query?.page_of_number || 30,
      },
    })
    router.replace({ path: route.path, query: { ...omit(route.query, !formData.value.group_id ? 'group_id' : ''), page: 1 } })
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'alumni', type: 'unCheckAll', data: [] })
    isFilter.value = true
    const dataTableElement = document.getElementById('data-table')
    if (dataTableElement) {
      const topPosition = dataTableElement.getBoundingClientRect().top + window.scrollY - 70
      window.scrollTo({ top: topPosition })
    }
  } catch (error) {
    console.log(error)
  }
}

const resetDataDetail = ref(false)
const onReset = (): void => {
  formData.value = {
    keyword: '',
    status: 'examinated',
    direct: false,
    group_id: '',
    detail_search: {
      community_info: {
        birthday: {
          start: '',
          end: '',
        },
        email: '',
        institution: '',
        job_type_parent_id: '',
        job_type_child_id: '',
        enrollment_start_period: '',
        portfolio_personal_activities: {
          title: '',
          content: '',
        },
        portfolio_work_histories: {
          position: '',
          department_name: '',
          content: '',
          portfolio_work_history_corporation_name: '',
          job_type_parent_id: '',
          job_type_child_id: '',
          start_period: '',
          end_period: '',
        },
        management_no: [],
        address: '',
        additional_information_1: '',
        additional_information_2: '',
        additional_information_3: '',
        additional_information_4: '',
        additional_information_5: '',
        corporation_organization_name: '',
        corporation_department_name: '',
        corporation_start_period: '',
        corporation_end_period: '',
      },
      management_flag: {
        flag_id: [],
        condition: '', //and || 'or'
        condition_not: false,
      },
      actions: {
        start_period: '',
        end_period: '',
        action_search_detail: [
          {
            action_search: '',
            action_count: {
              from: '',
              to: '',
            },
          },
        ],
      },
    },
  }
  resetDataDetail.value = true
}
const transitOE10 = () => {
  router.push(`/community/communities/${route.params?.id}/alumnus?management_no=desc`)
}
const transitOE12 = () => {
  router.push(`/community/communities/${route.params?.id}/community-users?management_no=desc`)
}
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('OE30userManagement'),
    to: '',
    active: false,
  },
  {
    content: `${translate('OE10listUser')}（${translate('almunai')}）`,
    to: '',
    active: true,
  },
]

const listStatus = [
  { title: translate('OE10participating'), value: 'examinated' },
  { title: translate('withdrawal'), value: 'deleted' },
  { title: translate('OE10pause'), value: 'available' },
  { title: translate('all'), value: 'all' },
]

const getCommunityAlumnus = ({ params, data }: { params: any; data: any }) => {
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_LIST_COMMUNITY_ALUMNUS, { id: router.currentRoute.value.params?.id, data, params })
}

onMounted(() => {
  store.dispatch(GROUPS_STORE.ACTIONS.SET_ALL_GROUPS, { id: route.params?.id })
})

onMounted(() => {
  if (Object.keys(route.query).length === 0 && router.currentRoute.value.path.match('/alumnus')?.length) {
    router.replace({ path: route.path, query: { management_no: 'asc' } })
  }
  if (dataSearch.value?.formData?.status) {
    formData.value = dataSearch.value.formData
    tabNow.value = dataSearch.value.tabNow
    dataTable.value = { ...formData.value }
  }
  getCommunityAlumnus({
    data: { keyword: formData.value.keyword, direct: formData.value.direct, status: formData.value.status, detail_search: formData.value.detail_search },
    params: {
      group_id: formData.value.group_id,
      ...router.currentRoute.value.query,
      // 2022/11/08 TienNV Fix bug selected user disappears when back previous page  UAT#4500: OE10(Ph2-R20221111)
      //management_no: route.query?.management_no,
      page_of_number: router.currentRoute.value.query?.page_of_number || 30,
    },
  })
})

watch(
  () => route.query?.group_id,
  () => {
    if (route.query?.group_id) {
      formData.value.group_id = route.query?.group_id
    }
  },
  { immediate: true }
)

watch(
  () => route.path,
  () => {
    let pathParent = `/${route.path.split('/')[1]}/communities/${route.params?.id}/alumnus`

    if (
      !route.path.match('/alumnus/send_messages') &&
      !route.path.match('/alumnus/granted_points') &&
      !route.path.match('/alumnus/alumnus-management-flag-update') &&
      route.path !== pathParent
    ) {
      store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DATA_SEARCH_ALUMNUS, [])
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'clearData', data: [] })
      onReset()
    }
  },
  { immediate: true }
)

const ClearRoute = () => {
  router.push({ path: route.path, query: { ...omit(route.query, 'group_id') } })
}
const changeStatusShowSearch = () => {
  showAdvanceSearch.value = !showAdvanceSearch.value
  if (!showAdvanceSearch.value) {
    tabInfo.value = false
    tabFlag.value = false
    tabAction.value = false
    Object.assign(formData.value.detail_search, {
      community_info: {
        birthday: {
          start: '',
          end: '',
        },
        email: '',
        institution: '',
        job_type_parent_id: '',
        job_type_child_id: '',
        enrollment_start_period: '',
        portfolio_personal_activities: {
          title: '',
          content: '',
        },
        portfolio_work_histories: {
          position: '',
          department_name: '',
          content: '',
          portfolio_work_history_corporation_name: '',
          job_type_parent_id: '',
          job_type_child_id: '',
          start_period: '',
          end_period: '',
        },
        management_no: [],
        address: '',
        additional_information_1: '',
        additional_information_2: '',
        additional_information_3: '',
        additional_information_4: '',
        additional_information_5: '',
        corporation_organization_name: '',
        corporation_department_name: '',
        corporation_start_period: '',
        corporation_end_period: '',
      },
      management_flag: {
        flag_id: [],
        condition: '', //and || 'or'
        condition_not: false,
      },
      actions: {
        start_period: '',
        end_period: '',
        action_search_detail: [
          {
            action_search: '',
            action_count: {
              from: '',
              to: '',
            },
          },
        ],
      },
    })
  } else {
    changeTab(tabNow.value)
  }
}

const formDetail = (data) => {
  resetDataDetail.value = false
  Object.assign(formData.value.detail_search, {
    community_info: {
      birthday: {
        start: data?.dob_start ?? '',
        end: data?.dob_end ?? '',
      },
      email: data?.email ?? '',
      institution: data?.institution ?? '',
      job_type_parent_id: data?.jobTypeParentId ?? '',
      job_type_child_id: data?.jobTypeChildId ?? '',
      enrollment_start_period: data?.enrollmentStartPeriod ?? '',
      portfolio_personal_activities: {
        title: data?.personalTitle ?? '',
        content: data?.personalContents ?? '',
      },
      portfolio_work_histories: {
        position: data?.workPosition ?? '',
        department_name: data?.workDepartment ?? '',
        content: data?.workContents ?? '',
        portfolio_work_history_corporation_name: data?.portfolioWorkHistoryCorporationName ?? '',
        job_type_parent_id: data?.historyJobTypeParentId ?? '',
        job_type_child_id: data?.historyJobTypeChildId ?? '',
        start_period: data?.startPeriod ?? '',
        end_period: data?.endPeriod ?? '',
      },
      management_no: data?.management_no ?? [],
      address: data?.address ?? '',
      additional_information_1: data?.additionalInformation1 ?? '',
      additional_information_2: data?.additionalInformation2 ?? '',
      additional_information_3: data?.additionalInformation3 ?? '',
      additional_information_4: data?.additionalInformation4 ?? '',
      additional_information_5: data?.additionalInformation5 ?? '',
      corporation_organization_name: data?.corporationOrganizationName ?? '',
      corporation_department_name: data?.corporationDepartmentName ?? '',
      corporation_start_period: data?.corporationStartPeriod ?? '',
      corporation_end_period: data?.corporationEndPeriod ?? '',
    },
    management_flag: {
      flag_id: data?.managementFlag ?? [],
      condition: data?.searchConditions ?? '',
      condition_not: data?.conditionNotFlagData ?? false,
    },
    actions: {
      start_period: data?.start_period ?? '',
      end_period: data?.end_period ?? '',
      action_search_detail: [
        {
          action_search: data?.action_search ?? '',
          action_count: {
            from: data?.action_count_from && !['community_participation', 'last_login'].includes(data?.action_search) ? data?.action_count_from : '',
            to: data?.action_count_to && !['community_participation', 'last_login'].includes(data?.action_search) ? data?.action_count_to : '',
          },
          condition1_not: data?.condition1_not ?? false,
        },
      ],
    },
  })
  if (data.action_search1) {
    let dataActionSearch = {
      action_search: data?.action_search1 ?? '',
      action_count: {
        from: data?.action_count_from1 && !['community_participation', 'last_login'].includes(data?.action_search1) ? data?.action_count_from1 : '',
        to: data?.action_count_to1 && !['community_participation', 'last_login'].includes(data?.action_search1) ? data?.action_count_to1 : '',
      },
      condition2_not: data?.condition2_not ?? false,
    }
    formData.value.detail_search.actions.action_search_detail.push(dataActionSearch)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('OE10listUsers')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "w-50 h-100 text-center bg-alumnus",
            onClick: transitOE10
          }, _toDisplayString(_unref(translate)('OE10alumnus')), 1),
          _createElementVNode("div", {
            class: "w-50 h-100 text-center bg-enroll-users",
            onClick: transitOE12
          }, _toDisplayString(_unref(translate)('CD40enrolledUser')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)('simpleSearch')), 1),
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('username')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: _unref(translate)('placeholder'),
                    maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
                    class: "form-control w-100 position-absolute fs-7",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.keyword) = $event))
                  }, null, 8, _hoisted_13), [
                    [
                      _vModelText,
                      formData.value.keyword,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)('OE10situation')), 1),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(listStatus, (status, index) => {
                  return _createElementVNode("div", {
                    class: "form-check me-4",
                    key: index
                  }, [
                    _createElementVNode("label", {
                      class: "form-check-label fs-7",
                      for: status.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "situation",
                        id: status.value,
                        "onUpdate:modelValue": ($event: any) => ((formData.value.status) = $event),
                        value: status.value
                      }, null, 8, _hoisted_18), [
                        [_vModelRadio, formData.value.status]
                      ]),
                      _createTextVNode(" " + _toDisplayString(status.title), 1)
                    ], 8, _hoisted_17)
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)('userDirect')), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", {
                    class: "form-check-label fs-7",
                    for: _ctx.unread
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "checkUserUnread",
                      id: _ctx.unread,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.direct) = $event)),
                      value: formData.value.direct
                    }, null, 8, _hoisted_24), [
                      [_vModelCheckbox, formData.value.direct]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('OE10unreadChat')), 1)
                  ], 8, _hoisted_23)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(translate)('group')), 1),
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select fs-7",
                  "aria-label": "Default select example",
                  name: "affiliation",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.group_id) = $event)),
                  onChange: ClearRoute
                }, [
                  _createElementVNode("option", _hoisted_28, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listGroups), (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.name), 9, _hoisted_29))
                  }), 128))
                ], 544), [
                  [_vModelSelect, formData.value.group_id]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", {
            class: "cursor-pointer fs-9",
            style: {"padding-right":"5px"},
            onClick: changeStatusShowSearch
          }, _toDisplayString(_unref(translate)('OE10support')), 1),
          (showAdvanceSearch.value)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "fa-solid fa-angle-down active-icon cursor-pointer icon",
                onClick: changeStatusShowSearch
              }))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "fas fa-chevron-up cursor-pointer icon",
                onClick: changeStatusShowSearch
              }))
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_31, [
          _createElementVNode("ul", _hoisted_32, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab, index) => {
              return _createElementVNode("li", {
                key: tab.title,
                onClick: ($event: any) => (changeTab(tab.alias)),
                class: _normalizeClass([
              tabNow.value === tab.alias ? 'active' : '',
              'fw-bold position-relative text-lg-start text-center ',
              index === 0 && tabs?.length > 2 && 'first-li',
              index === 0 && tabs?.length <= 2 && 'first-li-2',
              index === tabs?.length - 1 && 'last-li',
            ])
              }, [
                _createTextVNode(_toDisplayString(tab.title) + " ", 1),
                (tab.unread_count)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                  : _createCommentVNode("", true),
                _hoisted_35
              ], 10, _hoisted_33)
            }), 64))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(InfoFilter, {
              onFormDetail: formDetail,
              resetDataDetail: resetDataDetail.value,
              tabInfo: tabInfo.value,
              filterForAlumni: true
            }, null, 8, ["resetDataDetail", "tabInfo"])
          ], 512), [
            [_vShow, tabNow.value === 'info']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(FlagFilter, {
              onFormDetail: formDetail,
              resetDataDetail: resetDataDetail.value,
              tabFlag: tabFlag.value,
              filterForAlumni: true
            }, null, 8, ["resetDataDetail", "tabFlag"])
          ], 512), [
            [_vShow, tabNow.value === 'flag']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(ActionFilter, {
              onFormDetail: formDetail,
              resetDataDetail: resetDataDetail.value,
              tabAction: tabAction.value,
              filterForAlumni: true
            }, null, 8, ["resetDataDetail", "tabAction"])
          ], 512), [
            [_vShow, tabNow.value === 'action']
          ])
        ], 512), [
          [_vShow, showAdvanceSearch.value]
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(Button, {
            title: _unref(translate)('OE10clearData'),
            type: 'secondary',
            "class-name": 'me-4',
            onClick: onReset
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: _unref(translate)('OE10searchThisCondition'),
            type: 'secondary',
            htmlType: 'submit'
          }, null, 8, ["title"])
        ])
      ], 40, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _withDirectives(_createVNode(TableUsers, {
        dataQuery: dataTable.value,
        isFilter: isFilter.value
      }, null, 8, ["dataQuery", "isFilter"]), [
        [_vShow, !_unref(loading)]
      ])
    ]),
    _createVNode(Loading, { loading: _unref(loading) }, null, 8, ["loading"])
  ], 64))
}
}

})